import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

function BigScreenLogout({ history }) {
  const logoutUser = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('email');
    // eslint-disable-next-line react/prop-types
    history.push('/');
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
    <li className="nav-item" onClick={logoutUser} style={{ cursor: 'pointer' }}>
      <span className="nav-link">
        <i className="fas fa-sign-out-alt" />
        Logout
      </span>
    </li>
  );
}

BigScreenLogout.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
};

export default withRouter(BigScreenLogout);
